export enum ScheduleDayType {
    working = 1,
    vacation = 2,
    weekend = 4,
    requestedVacation = 8,
}